import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid"; // استيراد DataGrid
import "../assets/css/ShipmentDetails.css";
import axios from "axios";
import {
  CircularProgress,
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import NoPodPlaceholder from "../assets/images/no_pod_placeholder.png";
import NavBar from "../components/NavBar";

// دالة تحويل تفاصيل الحالة إلى الحالة الرئيسية (العمود الأخير على الشمال)
const mapStatusNameToMain = (rawStatus) => {
  if (!rawStatus) return "N/A";
  const lower = rawStatus.toLowerCase().trim();

  if (/delivered\s*and\s*morfak/i.test(lower)) {
    return "Delivered and Morfak Returned";
  }
  if (
    /^shipment\s*delivered$/i.test(lower) ||
    /^delivered$/i.test(lower) ||
    /correct\s*pod/i.test(lower) ||
    /delivered\s*&\s*w/i.test(lower)
  ) {
    return "Shipment Delivered";
  }
  if (/delivered/i.test(lower) && !/not\s*delivered|undelivered|failed/i.test(lower)) {
    return "Shipment Delivered";
  }

  if (/returned\s*to\s*shipper/i.test(lower) || /returned\s*to\s*s/i.test(lower)) {
    return "Returned To Shipper";
  }

  if (/lost/i.test(lower)) {
    return "Lost";
  }

  if (/^damaged$/i.test(lower) || /^damagd$/i.test(lower)) {
    return "Damaged";
  }

  if (/wrong\s*delivery/i.test(lower)) {
    return "Wrong Delivery";
  }

  if (/out\s*of\s*zone/i.test(lower) || /hold\s*to\s*be\s*ret/i.test(lower) || /^undelivered$/i.test(lower)) {
    return "Undelivered";
  }

  if (
    /hold\s*@\s*nasr/i.test(lower) ||
    /received\s*@\s*gi/i.test(lower) ||
    /hold\s*for\s*custo/i.test(lower) ||
    /hold\s*at\s*delivery\s*station/i.test(lower)
  ) {
    return "Hold at Delivery Station";
  }

  if (/hold\s*@\s*alex/i.test(lower) || /held\s*for\s*p-up/i.test(lower) || /under\s*process/i.test(lower)) {
    return "Under Process";
  }

  if (
    /^in\s*transit$/i.test(lower) ||
    /forward\s*to\s*ba/i.test(lower) ||
    /forward\s*to\s*gc/i.test(lower)
  ) {
    return "In transit";
  }

  return "In Process";
};

const getMainStatus = (item) => {
  if (!item) return "N/A";
  if (typeof item === "string") {
    return mapStatusNameToMain(item);
  }

  const rawStatus = (item.StatusName || item.Status || "").trim();

  const explicitMain =
    item.StateName ||
    item.MainStatus ||
    item.StatusCategory ||
    item.MainStatusName ||
    item.State ||
    item.ShipmentStatus;

  if (explicitMain && explicitMain.toLowerCase().trim() !== rawStatus.toLowerCase().trim()) {
    return explicitMain;
  }

  return mapStatusNameToMain(rawStatus);
};

const ShipmentDetails = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const {
    shipmentDetails,
    shipmentTracking,
    shipmentComplaint,
    ComplaintsActions,
  } = location.state;
  const [complaintType, setComplaintType] = useState([]);
  const [formData, setFormData] = useState({
    TypeID: "",
    Email: "",
    Telephone: shipmentDetails?.[0]?.Phone1 || "",
    Details: "",
    AWB: shipmentDetails?.[0]?.AWB || "",
    Subject: "",
  });

  const [loading, setLoading] = useState(false); // إضافة حالة الـ Loading
  const [podOpen, setPodOpen] = useState(false);
  const [podImage, setPodImage] = useState(null);
  const [podLoading, setPodLoading] = useState(false);

  const handleFetchPOD = () => {
    const awb = shipmentDetails?.[0]?.AWB;
    if (awb) {
      setPodImage(`https://cs.gexpress-eg.com/cs/POD/${awb}.jpg`);
    } else {
      setPodImage(null);
    }
    setPodOpen(true);
  };
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    // جلب أنواع الطلبات من API
    axios
      .get("https://vsoftapi.com-eg.net/api/ClientUsers/V6/GetTicketTypes", {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        const data = Array.isArray(response.data)
          ? response.data
          : response.data?.Data || [];
        setComplaintType(data);
      })
      .catch((error) => {
        console.error("Error fetching ticket types:", error);
        setComplaintType([]); // في حالة الخطأ قم بتحديد مصفوفة فارغة
      });
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleCloseModal = () => {
    setIsModalOpen(false); // إغلاق المودال
    navigate("/cs-home");
  };
  const handleSubmit = (e) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    e.preventDefault();
    setLoading(true); // تفعيل الـ Loading عند إرسال البيانات

    axios
      .post("https://vsoftapi.com-eg.net/api/ClientUsers/V6/SaveTicket", formData, {
        headers: {
          CompanyID: userData.Data.CompanyID,
          AccessToken: userData.Data.AccessToken,
        },
      })
      .then((response) => {
        setLoading(false); // إخفاء الـ Loading بعد إرسال البيانات
        setIsModalOpen(true);
      })
      .catch((error) => {
        setLoading(false); // إخفاء الـ Loading بعد الفشل
        console.error("Error submitting complaint:", error);
        alert("Failed to submit complaint.");
      });
  };
  const complaintRows =
    Array.isArray(shipmentComplaint) && shipmentComplaint.length > 0
      ? shipmentComplaint.map((complaint, index) => ({
          id: index + 1,
          ComplaintDate: complaint?.ComplaintDate || "N/A",
          ComplaintType: complaint?.ComplaintType || "N/A",
          ComplaintSubject: complaint?.ComplaintSubject || "N/A",
          status: complaint?.ComplaintStatus || "N/A",
          details: complaint?.CompplaintDetails || "N/A",
        }))
      : [];
  const complaintColumns = [
    { field: "ComplaintDate", headerName: "Date", width: 200 },
    { field: "ComplaintType", headerName: "Call Type", width: 200 },
    { field: "status", headerName: "Status", width: 200 },
    { field: "ComplaintSubject", headerName: "Call Subject", width: 200 },
    { field: "details", headerName: "Call Details", flex: 1 },
  ];
  const supportRows =
    Array.isArray(ComplaintsActions) && ComplaintsActions.length > 0
      ? ComplaintsActions.map((complaint, index) => ({
          id: index + 1,
          serial: complaint?.ComplaintID || "N/A",
          ComplaintDate: complaint?.ActionDate || "N/A",
          status: complaint?.Status || "N/A",
          IsClosed: complaint?.IsClosed || "N/A",
          Notes: complaint?.Notes || "N/A",
        }))
      : [];

  const supportColumns = [
    { field: "serial", headerName: "ComplaintID", width: 150 },
    { field: "ComplaintDate", headerName: "Complaint Date", width: 200 },
    { field: "status", headerName: "Complaint Status", width: 150 },
    { field: "IsClosed", headerName: "Is Closed", width: 150 },
    { field: "Notes", headerName: "Notes", width: 150 },
  ];

  return (
    <>
      <NavBar />
      <div className="details-page">
      <div className="header">
        <h1>Shipment Info</h1>
        <Button
          onClick={() => navigate("/cs-home")}
          className="back-btn"
        >
          {t("Back to Search") || "Back to Search"}
        </Button>
      </div>
      <div className="content">
        <div className="right-panel">
          <div className="shipment-card">
            <h2>Shipment Info</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">AWB Number</span>
                <span className="info-value highlighted">{shipmentDetails?.[0]?.AWB || "N/A"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Status</span>
                {(() => {
                  const mainStatus = getMainStatus(shipmentDetails?.[0]);
                  return (
                    <span className={`status-badge ${mainStatus.toLowerCase().replace(/\s+/g, '-')}`}>
                      {mainStatus}
                    </span>
                  );
                })()}
              </div>
              <div className="info-item">
                <span className="info-label">Pickup Date</span>
                <span className="info-value">
                  {shipmentDetails?.[0]?.PickupDate
                    ? new Date(shipmentDetails[0].PickupDate).toLocaleDateString()
                    : "N/A"}
                </span>
              </div>
              {shipmentDetails?.[0]?.SpecialInstruction && (
                <div className="info-item full-width">
                  <div className="notes-banner">
                    <strong>Special Instructions:</strong> {shipmentDetails[0].SpecialInstruction}
                  </div>
                </div>
              )}
              <div className="info-item full-width" style={{ marginTop: "10px" }}>
                <Button
                  variant="outlined"
                  onClick={handleFetchPOD}
                  sx={{
                    borderColor: "var(--accent-orange)",
                    color: "var(--accent-orange)",
                    fontWeight: 700,
                    textTransform: "none",
                    borderRadius: "8px",
                    width: "fit-content",
                    px: 3,
                    py: 1,
                    '&:hover': {
                      borderColor: "#e03f14",
                      backgroundColor: "rgba(239, 75, 31, 0.04)"
                    }
                  }}
                >
                  View Proof of Delivery (POD)
                </Button>
              </div>
            </div>
          </div>
          <div className="sender-card">
            <h2>Shipper and Consignee Info</h2>
            <div className="info-grid">
              <div className="info-item">
                <span className="info-label">Consignee Name</span>
                <span className="info-value">{shipmentDetails?.[0]?.ConsigneeName || "N/A"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Mobile</span>
                <span className="info-value">{shipmentDetails?.[0]?.Phone1 || "N/A"}</span>
              </div>
              <div className="info-item full-width">
                <span className="info-label">Address</span>
                <span className="info-value">{shipmentDetails?.[0]?.Address || "N/A"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">COD Amount</span>
                <span className="info-value highlighted">{shipmentDetails?.[0]?.COD != null ? `${shipmentDetails[0].COD} EGP` : "N/A"}</span>
              </div>
              <div className="info-item">
                <span className="info-label">Product Type</span>
                <span className="info-value">{shipmentDetails?.[0]?.Product || "N/A"}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="left-panel">
          <h2>Shipment History</h2>
          <div className="timeline">
            {shipmentTracking?.length > 0 ? (
              [...shipmentTracking]
                .sort((a, b) => new Date(b.AuditDate) - new Date(a.AuditDate))
                .map((track, index) => {
                  const mainStatus = getMainStatus(track);
                  const subStatus = track.StatusName || track.StatusNameA || track.StatusNameE;

                  const isNotDelivered =
                    (subStatus &&
                      /not\s*delivered|undelivered|failed|لم يتم التسليم|غير مسلم|تعذر|عدم التسليم/i.test(subStatus)) ||
                    (mainStatus &&
                      /not\s*delivered|undelivered|failed|لم يتم التسليم|غير مسلم|تعذر|عدم التسليم/i.test(mainStatus));

                  const reason =
                    track.ReasonName ||
                    track.Reason ||
                    track.ReasonDescription ||
                    track.FailedReason ||
                    track.NotDeliveredReason ||
                    track.UpdateNotes ||
                    track.Notes ||
                    track.Remarks ||
                    track.Comment;

                  return (
                    <div key={index} className="timeline-item">
                      <div className="timeline-node"></div>
                      <div className="timeline-content">
                        <div className="timeline-header">
                          <span className="timeline-status">{mainStatus}</span>
                          <span className="timeline-date">
                            {track.AuditDate ? new Date(track.AuditDate).toLocaleString() : ""}
                          </span>
                        </div>
                        {isNotDelivered && (
                          <div className="timeline-reason-banner">
                            <strong>Reason / السبب:</strong> {reason || "N/A"}
                          </div>
                        )}
                        {track.UpdateNotes && (!isNotDelivered || track.UpdateNotes !== reason) && (
                          <p className="timeline-notes">{track.UpdateNotes}</p>
                        )}
                      </div>
                    </div>
                  );
                })
            ) : (
              <p>No tracking history available.</p>
            )}
          </div>
        </div>
      </div>

      {/* جدول الشكاوى */}
      <div className="complaints-section">
        <h2>Tickets</h2>
        <div style={{ width: "100%" }}>
          <DataGrid
            rows={complaintRows}
            columns={complaintColumns}
            pageSize={5}
            autoHeight
          />
        </div>
      </div>

      {/* جدول الدعم الفني */}
      <div className="support-section">
        <h2>Technical Support</h2>
        <div style={{ width: "100%" }}>
          <DataGrid 
            rows={supportRows} 
            columns={supportColumns} 
            pageSize={5} 
            autoHeight
          />
        </div>
      </div>
      <div className="complaint-container">
        <div className="complaint-header">Add Ticket</div>
        <form onSubmit={handleSubmit}>
          <div className="form-grid">
            <div className="form-group">
              <label>Request Type</label>
              <select
                name="TypeID"
                value={formData.TypeID}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Request Type</option>
                {complaintType?.map((type) => (
                  <option key={type.TypeID} value={type.TypeID}>
                    {type.TypeNameE || type.EnglishNAme || type.TypeNameA}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Subject</label>
              <input
                type="text"
                name="Subject"
                value={formData.Subject || ""}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group full-width">
              <label>Details</label>
              <textarea
                name="Details"
                value={formData.Details}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <button type="submit" className="btn-submit">
            {loading ? <CircularProgress size={24} /> : "Save"}
          </button>
        </form>
        <Dialog open={isModalOpen} onClose={handleCloseModal}>
          <DialogTitle>{t("shipmentSavedSuccessfully")}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {t("shipmentSavedSuccessfully")}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleCloseModal}
              variant="contained"
              color="primary"
            >
              {t("cancel")}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog 
          open={podOpen} 
          onClose={() => setPodOpen(false)}
          maxWidth="md"
          fullWidth
          PaperProps={{
            style: {
              borderRadius: "16px",
              padding: "20px",
            }
          }}
        >
          <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontWeight: 700, p: 1 }}>
            Proof of Delivery (POD)
          </DialogTitle>
          <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", p: 2 }}>
            {podImage ? (
              <img 
                src={podImage} 
                alt="Proof of Delivery" 
                style={{ maxWidth: "100%", maxHeight: "500px", objectFit: "contain", borderRadius: "8px" }} 
                onError={() => setPodImage(null)}
              />
            ) : (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "15px" }}>
                <img 
                  src={NoPodPlaceholder} 
                  alt="No POD available" 
                  style={{ maxWidth: "250px", maxHeight: "250px", objectFit: "contain" }} 
                />
                <span style={{ fontSize: "16px", fontWeight: 600, color: "#64748b" }}>
                  No Proof of Delivery (POD) image available for this shipment.
                </span>
              </div>
            )}
          </DialogContent>
          <DialogActions sx={{ justifyContent: "center", p: 1 }}>
            <Button 
              onClick={() => setPodOpen(false)} 
              variant="contained" 
              color="primary"
              sx={{ fontWeight: 700, minWidth: "120px" }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
    </>
  );
};

export default ShipmentDetails;
